<template>
  <router-view />
</template>

<script setup>
// La landing y el dashboard se montan a través del router.
// El widget de mensajería anterior fue retirado para alinear la experiencia
// con la identidad SaaS B2B de LLEVO.
</script>
